export const FORM_LOGIN = 'FORM_LOGIN';
export const FORM_ABONO = 'FORM_ABONO';
export const FORM_VIAJE = 'FORM_VIAJE';
export const FORM_ROLES = 'FORM_ROLES';
export const FORM_PARADA = 'FORM_PARADA';
export const FORM_RESERVA = 'FORM_RESERVA';
export const FORM_RUTINAS = 'FORM_RUTINAS';
export const FORM_MENSAJE = 'FORM_MENSAJE';
export const FORM_ABONADOS = 'FORM_ABONADOS';
export const FORM_REGISTER = 'FORM_REGISTER';
export const FORM_VEHICULOS = 'FORM_VEHICULOS';
export const FORM_RECUPERATEPASS_CODE = 'FORM_RECUPERATEPASS_CODE';
export const FORM_RECUPERATEPASS_EMAIL = 'FORM_RECUPERATEPASS_EMAIL';
export const FORM_TRAYECTO = 'FORM_TRAYECTO';
export const FORM_TRAYECTO_PARADA = 'FORM_TRAYECTO_PARADA';
export const FORM_GRUPO = 'FORM_GRUPO';
export const FORM_PRECIOS = 'FORM_PRECIOS';
export const FORM_TRAYECTO_FOTO = 'FORM_TRAYECTO_FOTO';



// WEBPACK FOOTER //
// src/modules/forms/formConstants.js